type TPaymentMethodForAria = {
  title: string;
  note?: string;
};

/** Accessible name for payment radios; includes supplementary copy (e.g. pay-later cash) when present. */
export function getPaymentMethodAriaLabel(paymentMethod: TPaymentMethodForAria): string {
  return paymentMethod.note ? `${paymentMethod.title}. ${paymentMethod.note}` : paymentMethod.title;
}
